import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {finalize} from 'rxjs/operators';
import {LoadingService} from '../services/loading.service';


@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(
    private loadingService: LoadingService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isBackground = req.params.get('silent');

    if (!isBackground) {
      this.loadingService.showLoading();
    }

    const cloneReq = req.clone({
      params: req.params.delete('silent'),
    });

    const authReq = cloneReq.clone();

    return next.handle(authReq).pipe(finalize(() => {
        if (!isBackground) {
          this.loadingService.hideLoading();
        }
      })
    );
  }
}
